export default {
	messages: {
		required: (field) => `Este campo es requerido`,
		length: (field) => `El campo está mal formado`,
		max: (field) => `El campo está mal formado`,
		min: (field) => `El campo no tiene la longitud mínima requerida`,
		integer: (field) => `El campo está mal formado`,
		digits: (field) => `El campo está mal formado`,
		regex: (field) => `El campo está mal formado, debe ser un número`,
		numeric: (field) => `El campo está mal formado`,
		email: (field) => 'El campo email está mal formado'
	},
	custom: {
		email: {
			required: 'El campo email es obligatorio',
			email: 'Debes indicar una dirección de correo electrónico válida'
		},
		informacionTratamientoDeDatos:{
			required: 'Este campo es obligatorio',
		},
		email_firmante: {
			email: 'Debes indicar una dirección de correo electrónico válida'
		},
		telefono: {
			required: 'El campo teléfono es obligatorio',
			length: 'El campo teléfono está mal formado',
			min: 'El campo teléfono está mal formado',
			max: 'La longitud del teléfono es excesiva'
		},
		nombre: {
			required: 'El campo nombre es obligatorio'
		},
		mensaje: {
			required: 'El campo mensaje es obligatorio'
		},
		apellidos: {
			required: 'El campo apellidos es obligatorio'
		},
		cif: {
			required: 'El campo cif es obligatorio',
			length: 'El campo cif está mal formado',
		},
		nombre_usuario: {
			required: 'El campo nombre de usuario es obligatorio'
		},
		puesto: {
			required: 'El campo puesto es obligatorio'
		},
		telefono: {
			required: 'El campo teléfono es obligatorio',
			length: 'El campo teléfono está mal formado',
			min: 'El campo teléfono está mal formado',
			max: 'La longitud del teléfono es excesiva'
		},
		telefono_empresa: {
			required: 'El campo teléfono es obligatorio',
			length: 'El campo teléfono está mal formado',
			min: 'El campo teléfono está mal formado',
			max: 'La longitud del teléfono es excesiva'
		},
		telefono2: {
			required: 'El campo teléfono es obligatorio',
			length: 'El campo teléfono está mal formado',
			min: 'El campo teléfono está mal formado',
			max: 'La longitud del teléfono es excesiva'
		},
		sede: {
			required: 'El campo sede es obligatorio'
		},
		experiencia: {
			required: 'El campo experiencia es obligatorio'
		},
		password: {
			required: 'El campo contraseña es obligatorio',
			min: 'La contraseña debe tener al menos 8 carácteres',
			confirmed: 'Las contraseñas no coinciden',
			digits: 'La contraseña debe contener al menos un numero'
		},
		password2: {
			required: 'El campo contraseña es obligatorio',
			min: 'La contraseña debe tener al menos 8 carácteres',
			confirmed: 'Las contraseñas no coinciden',
			digits: 'La contraseña debe contener al menos un numero'
		},
		politica: {
			required: 'Debes aceptar la política de privacidad'
		},
		direccion: {
			required: 'El campo direccion es obligatorio'
		},
		cp: {
			required: 'El campo código postal es obligatorio'
		},
		pais: {
			required: 'El campo país es obligatorio'
		},
		paiscontacto: {
			required: 'El campo país es obligatorio'
		},
		file: {
			size: 'El tamaño máximo son 10MB',
			mimes: 'El formato debe ser PDF'
		},
		filePoliza: {
			size: 'El tamaño máximo son 2MB',
			mimes: 'El formato debe ser PDF'
		},
		titulo: {
			required: 'El campo nombre de la oferta es obligatorio'
		},
		plazas: {
			required: 'El campo numero de plazas es obligatorio'
		},
		poblacion: {
			required: 'El campo población es obligatorio'
		},
		localidad: {
			required: 'El campo localidad es obligatorio'
		},
		provincia: {
			required: 'El campo provincia es obligatorio'
		},
		provinciacontacto: {
			required: 'El campo provincia es obligatorio'
		},
		horario: {
			required: 'El campo horario de trabajo es obligatorio'
		},
		horasAldia: {
			required: 'El campo horas al día es obligatorio',
			numeric: 'El campo horas al d´´ia debe ser un valor numérico'
		},
		ayudaEstudio: {
			required: 'El campo remuneración es obligatorio',
			numeric: 'El campo remuneración debe ser un valor numérico',
			decimal: 'El campo remuneración debe ser un valor numérico'
		},
		meses: {
			between: 'Debe ser un valor entre 0 y 12'
		},
		salario: {
			required: 'El campo renmuneración es obligatorio'
		},
		remuneraciones: {
			required: 'El campo otras remuneraciones es obligatorio'
		},
		tiempoDedicacionJornada: {
			between: 'Debe ser un valor entre 0 y 100'
		},
		numeroDiasSemana: {
			between: 'Debe ser un valor entre 1 y 7'
		},
		otrasRemuneraciones: {
			required: 'El campo otras remuneraciones es obligatorio'
		},
		contrato: {
			required: 'El campo tipo de contrato es obligatorio'
		},
		descripcion: {
			required: 'El campo descripcion es obligatorio'
		},
		curso: {
			required: 'El campo curso es obligatorio'
		},
		titulacion: {
			required: 'El campo titulación es obligatorio'
		},
		puestoTrabajo: {
			required: 'El campo puesto de trabajo es obligatorio'
		},
		horasDia: {
			required: 'El campo horas al día es obligatorio',
			numeric: 'El campo horas al día debe ser numérico'
		},
		departamentoalumno: {
			required: 'El campo departamento es obligatorio'
		},
		departamento: {
			required: 'El campo departamento es obligatorio'
		},
		nombreTutorEmpresa: {
			required: 'El campo nombre del tutor/a de la empresa es obligatorio'
		},
		ApellidosTutorEmpresa: {
			required: 'El campo apellidos del tutor/a de la empresa es obligatorio'
		},
		emailTutorEmpresa: {
			required: 'El campo email del tutor/a de la empresa es obligatorio',
			email: 'El campo email del tutor/a de la empresa está mal formado'
		},
		titulacionTutorEmpresa: {
			required: 'El campo titulación del tutor/a de la empresa es obligatorio'
		},
		nombreTutorUni: {
			required: 'El campo nombre del tutor/a de la universidad es obligatorio'
		},
		tareasAdesarrollar: {
			required: 'El campo tareas a desarrollar es obligatorio',
			min: 'El campo tareas a desarrollar no tiene la longitud mínima requerida'
		},
		nombreFiscal: {
			required: 'El campo nombre fiscal es obligatorio'
		},
		nombreComercial: {
			required: 'El campo nombre comercial es obligatorio'
		},
		codigo_postal: {
			required: 'El campo código postal es obligatorio'
		},
		area_funcional: {
			required: 'El campo área funcional es obligatorio'
		},
		fechaInicio: {
			required: 'El campo fecha de inicio es obligatorio'
		},
		fechaFin: {
			required: 'El campo fecha de fin es obligatorio'
		},
		tiempoDedicacionJornada: {
			required: 'El campo porcentaje de dedicación es obligatorio',
			integer: 'El campo porcentaje de dedicación debe ser un número entero',
			between: 'Debe ser un valor entre 0 y 100'
		},
		numeroDiasSemana: {
			required: 'El campo número de días por semana es obligatorio',
			between: 'Debe ser un valor entre 1 y 7',
			numeric: 'El campo número de días por semana debe ser numérico'
		},
		diasDeLaSemana: {
			required: 'El campo días de la semana es obligatorio'
		},
		telefonoTutorEmpresa: {
			required: 'El campo teléfono del tutor/a de la empresa es obligatorio',
			min: 'El campo teléfono del tutor/a de la empresa está mal formado',
			max: 'La longitud del teléfono del tutor/a de la empresa es excesiva'
		},
		cargoTutorEmpresa: {
			required: 'El campo cargo del tutor/a de la empresa es obligatorio'
		},
		dniTutorEmpresa: {
			required: 'El campo DNI del tutor/a de la empresa es obligatorio'
		},
		departamentoTutorEmpresa: {
			required: 'El campo departamento del tutor/a de la empresa es obligatorio'
		},
		nombre_comercial: {
			required: 'El campo nombre comercial es obligatorio'
		},
		nombre_fiscal: {
			required: 'El campo nombre fiscal es obligatorio'
		},
		listado_titulaciones: {
			required: 'Debe elegir al menos una titulación a la que se dirige la oferta'
		},
		privada: {
			required: 'El campo tipo de empresa es obligatorio'
		},
		tipoEmpresa: {
			min_value: 'El campo tipo de sociedad es obligatorio',
			required: 'El campo tipo de sociedad es obligatorio'
		},
		sector: {
			required: 'El campo sector es obligatorio'
		},
		startup: {
			required: 'El campo startup es obligatorio'
		},
		url: {
			url: 'La URL esta mal formada'
		},
		checkdni: {
			checkdni: "El DNI está mal formado"
		},
		iban: {
			checkiban: "El IBAN está mal formado"
		},
		urlInscripcionExterna: {
			regex: "La url contiene errores"
		},
		linkedin: {
			regex: "La url contiene errores"
		},
		nota : {
			between : "El dato debe estar entre 1 y 4"
		},
		tipo_oferta: {
			required: 'El campo tipo de oferta es obligatorio'
		},
		condicionespracticas: {
			required: 'Debes aceptar las condiciones de prácticas'
		},
		idProgramaPracticas: {
			required: 'El campo programa de prácticas es obligatorio'
		},
		experienciadeseable: {
			required: 'El campo experiencia deseable es obligatorio'
		},
		isla: {
			required: 'El campo isla es obligatorio'
		},
		idpoblacion: {
			required: 'El campo población es obligatorio'
		},
		horasAldia: {
			required: 'El campo horas al día es obligatorio',
			regex: 'El campo horas al día debe ser un número válido'
		},
		tipoopcionpublicacion: {
			required: 'El campo opción de publicación es obligatorio'
		},
		datosCandidatoPreferido: {
			required: 'El campo datos del candidato preferido es obligatorio'
		},
		conocimientosEspecificos: {
			required: 'El campo conocimientos específicos es obligatorio'
		},
		formacionAdquirida: {
			required: 'El campo formación adquirida es obligatorio'
		},
		seguimientoPrevisto: {
			required: 'El campo seguimiento previsto es obligatorio'
		},
		tareauno: {
			required: 'La tarea 1 es obligatoria'
		},
		tareados: {
			required: 'La tarea 2 es obligatoria'
		},
		tareatres: {
			required: 'La tarea 3 es obligatoria'
		},
		otratareas: {
			min: 'El campo otras tareas no tiene la longitud mínima requerida'
		},
		observacionesPublicas: {
			max: 'El campo observaciones públicas supera la longitud máxima'
		},
		nombrefirmante: {
			required: 'El campo nombre del firmante es obligatorio'
		},
		apellidosfirmante: {
			required: 'El campo apellidos del firmante es obligatorio'
		},
		cargofirmante: {
			required: 'El campo cargo del firmante es obligatorio'
		},
		emailfirmante: {
			required: 'El campo email del firmante es obligatorio',
			email: 'Debes indicar una dirección de correo electrónico válida'
		},
		telefonofirmante: {
			required: 'El campo teléfono del firmante es obligatorio',
			min: 'El campo teléfono del firmante está mal formado',
			max: 'La longitud del teléfono del firmante es excesiva'
		},
		tutores: {
			required: 'El campo tutor es obligatorio'
		},
		nombretutor: {
			required: 'El campo nombre del tutor es obligatorio'
		},
		apellidostutor: {
			required: 'El campo apellidos del tutor es obligatorio'
		},
		cargotutor: {
			required: 'El campo cargo del tutor es obligatorio'
		},
		emailtutor: {
			required: 'El campo email del tutor es obligatorio',
			email: 'Debes indicar una dirección de correo electrónico válida'
		},
		telefonotutor: {
			required: 'El campo teléfono del tutor es obligatorio',
			min: 'El campo teléfono del tutor está mal formado',
			max: 'La longitud del teléfono del tutor es excesiva'
		},
		departamentotutor: {
			required: 'El campo departamento del tutor es obligatorio'
		},
		dnitotutor: {
			required: 'El campo DNI del tutor es obligatorio'
		},
		titulaciontotutor: {
			required: 'El campo titulación del tutor es obligatorio'
		},
		cursoMinimoRequerido: {
			min: 'El curso mínimo debe ser mayor o igual a 1',
			numeric: 'El curso mínimo debe ser numérico'
		},
		listado_titulaciones_deseables: {
			required: 'Debe elegir al menos una titulación deseable'
		},
		listado_titulaciones_propuestas: {
			required: 'Debe elegir al menos una titulación propuesta'
		},
		anyopromocionmaximo: {
			required: 'El campo año máximo de promoción es obligatorio'
		}


	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js